import { render, staticRenderFns } from "./interfaceCarousel.vue?vue&type=template&id=2c8c577f&scoped=true&"
import script from "./interfaceCarousel.vue?vue&type=script&lang=js&"
export * from "./interfaceCarousel.vue?vue&type=script&lang=js&"
import style0 from "./interfaceCarousel.vue?vue&type=style&index=0&id=2c8c577f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c577f",
  null
  
)

export default component.exports